const IS_LOCAL_STORAGE = typeof localStorage !== 'undefined';

export { IS_LOCAL_STORAGE };
//# sourceMappingURL=constants.js.map
